/* eslint-disable no-shadow */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  toggleReviewModal,
  submitReview,
} from "../../actions/employerPendingReviewsActions";
import { toggleFinishJobPostModal } from "../../actions/dashboardActions";
import { ReviewModal } from "../ReviewModal/ReviewModal";
import FinishJobPost from "../FinishJobPost/FinishJobPost";

export class DashboardModal extends Component {
  componentDidMount() {
    const {
      pendingReview,
      toggleReviewModal,
      toggleFinishJobPostModal,
      finishJobPost,
      finishJobPostId,
    } = this.props;

    if (pendingReview) toggleReviewModal(pendingReview);
    if (finishJobPost) toggleFinishJobPostModal(finishJobPostId);
  }

  render() {
    const {
      reviewModalActive,
      formThankYou,
      formLoading,
      finishJobPostModalActive,
      finishJobPostData,
      pendingReview,
      toggleReviewModal,
      submitReview,
    } = this.props;

    return (
      <Fragment>
        {reviewModalActive && (
          <ReviewModal
            pendingReview={pendingReview}
            toggleReviewModal={toggleReviewModal}
            submitReview={submitReview}
            formThankYou={formThankYou}
            formLoading={formLoading}
          />
        )}
        {finishJobPostModalActive && (
          <FinishJobPost finishJobPostData={finishJobPostData} />
        )}
      </Fragment>
    );
  }
}

DashboardModal.propTypes = {
  pendingReview: PropTypes.shape({
    reviewId: PropTypes.number,
    jobId: PropTypes.number,
    jobTitle: PropTypes.string,
    agentName: PropTypes.string,
    agentCompany: PropTypes.string,
  }),
  toggleReviewModal: PropTypes.func.isRequired,
  submitReview: PropTypes.func,
  reviewModalActive: PropTypes.bool,
  formThankYou: PropTypes.bool,
  formLoading: PropTypes.bool,
  finishJobPost: PropTypes.bool,
  toggleFinishJobPostModal: PropTypes.func.isRequired,
  finishJobPostModalActive: PropTypes.bool.isRequired,
  finishJobPostData: PropTypes.shape({}),
  finishJobPostId: PropTypes.number,
};

DashboardModal.defaultProps = {
  pendingReview: PropTypes.isNull,
  reviewModalActive: PropTypes.isNull,
  finishJobPostData: PropTypes.isNull,
  finishJobPost: PropTypes.isNull,
  finishJobPostId: PropTypes.isNull,
  submitReview: PropTypes.isNull,
  formThankYou: PropTypes.isNull,
  formLoading: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  reviewModalActive: state.employerPendingReviews.reviewModalActive,
  formThankYou: state.employerPendingReviews.formThankYou,
  formLoading: state.employerPendingReviews.formLoading,
  finishJobPostModalActive: state.dashboard.finishJobPostModalActive,
  finishJobPostData: state.dashboard.finishJobPostData,
});

export default connect(mapStateToProps, {
  toggleReviewModal,
  submitReview,
  toggleFinishJobPostModal,
})(DashboardModal);
